import React, { Component } from "react";
import {
  profile,
  tokens,
  GET,
  POST,
  DELETE,
  alert,
  loading,
  Modal,
  t
} from "./CustomComponent.js";
import Language from "../components/Language.js";
import { Navbar, Nav } from "react-bootstrap";
import Logo from "./Logo.js";
import { COIN_ICON, coin } from "./wallet_option.js";
import TopupModal from "./wallet/TopupModal.js";
import { can } from "../utils/permission.js";
import { isPartnerUser } from "./people_option.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import "../assets/css/wallet.css";

/* user_type ที่มีแถบยอดเหรียญบนหัวหน้า — ใช้ตัดสินแค่ว่าจะวางโครงชิปตอนกำลังโหลด
   ไหมเท่านั้น ตัวคำตอบจริงมาจาก backend (wallet.service.getOverview) */
const WALLET_SCOPES = ["partner", "super_user"];

/* ผู้ใช้ภายในที่ได้เปิดกล่องเติมเหรียญดูแบบอ่านอย่างเดียว — เปิดให้เฉพาะคนที่ดูแล
   ระบบเหรียญอยู่แล้ว ไม่ใช่ทุกคนที่ล็อกอินเข้าหลังบ้าน : คนที่ไม่เกี่ยวกับเหรียญเลย
   (เช่นทีมการตลาด) เห็นปุ่มนี้ก็เป็นได้แค่ของเกะกะบนหัวหน้า กดแล้วก็ทำอะไรไม่ได้
   super_user ผ่าน can() อยู่แล้วโดยไม่ต้องติ๊กสิทธิ์ */
const TOPUP_PREVIEW_PERMISSIONS = ["wallet-topups.read", "wallet-settings.read"];
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total_balance_available: 0,
      total_balance_thb: 0,
      total_balance_lak: 0,
      dropdown: "",
      array_link: [...this.filterMenu(profile)],
      open_groups: this.defaultOpenGroups(),
      user_profile: profile,
      modal_news: false,
      announce_datetime: "",
      announce_duration: 0,
      announce_detail: "",

      // บัญชีของฉัน — ตอนนี้มีแค่การผูก LINE (ยังไม่มีหน้าโปรไฟล์เต็ม)
      //                 พาร์ตเนอร์ยังไม่ได้ใช้ส่วนนี้ ดู canOpenAccount
      modal_account: false,
      line_status: null,

      // ตัวเลขงานค้างบนเมนู { [badge key]: จำนวน } — ดู BADGE_SOURCES
      badges: {},

      /* ยอดเหรียญบนหัวหน้า — รูปร่างต่างกันตาม scope ที่ backend ตัดสินจาก user_type
         own = พาร์ตเนอร์เห็นกระเป๋าตัวเอง / all = super_user เห็นยอดรวมทั้งระบบ
         none = ผู้ใช้ภายในคนอื่น ไม่ต้องแสดงแถบนี้ (ดู wallet.service.getOverview) */
      wallet: null,
      wallet_loading: true,

      /* กล่องเติมเหรียญ — เปิดจากปุ่มข้างชิปยอดเหรียญ (พาร์ตเนอร์ส่งคำขอได้จริง
         ฝั่งแอดมินเปิดดูได้อย่างเดียว ดู componentTopup)
         อยู่ที่ Navbar เพราะต้องกดได้จากทุกหน้าโดยไม่ทิ้งงานที่ทำค้างไว้ */
      topup_open: false,
    };
  }

  /* ============================================================ ตัวเลขบนเมนู
   * เมนูที่ประกาศ badge ไว้ใน global.menu_admin จะมาดึงยอดจากที่นี่
   * key ต้องตรงกับค่า badge ของเมนูนั้น
   *
   * ดึงเฉพาะเมนูที่ผู้ใช้คนนั้นเห็นจริง (filterMenu กรองมาแล้ว) — ไม่งั้นบัญชีที่ไม่มี
   * สิทธิ์จะยิงคำขอที่รู้อยู่แล้วว่าจะได้ 403 กลับมาทุกครั้งที่เปิดหน้า
   *
   * ยิงไม่ผ่านก็ไม่เป็นไร ปล่อยให้ไม่มีตัวเลขไปเงียบ ๆ — badge เป็นของแถม
   * ไม่ใช่ข้อมูลที่ขาดแล้วหน้าจอใช้งานไม่ได้ จึงไม่ควรเด้ง error ใส่ผู้ใช้
   * ========================================================================= */
  BADGE_SOURCES = {
    // ใบสมัครพาร์ตเนอร์ที่ยังไม่ได้ตัดสิน (pending + reviewing)
    partners_open: async () => {
      const result = await GET("admin/partners/summary");
      return result?.status ? Number(result.data?.open) || 0 : 0;
    },

    // คำขอเติมเหรียญที่ยังรอตรวจสอบ — คิวที่ทีมการเงินต้องเคลียร์ทุกวัน
    topups_open: async () => {
      const result = await GET("admin/wallet-topups/summary");
      return result?.status ? Number(result.data?.open) || 0 : 0;
    },
  };

  GetBadges = async () => {
    const wanted = [
      ...new Set(
        this.state.array_link
          .flatMap((item) => (item.children ? item.children : [item]))
          .map((item) => item.badge)
          .filter((key) => key && this.BADGE_SOURCES[key])
      ),
    ];
    if (!wanted.length) return;

    const values = await Promise.all(
      wanted.map((key) => this.BADGE_SOURCES[key]().catch(() => 0))
    );

    this.setState({ badges: Object.fromEntries(wanted.map((key, i) => [key, values[i]])) });
  };

  icon = (io) => <span className="icon">{io}</span>;

  /* ============================================================ ยอดเหรียญ
   * ยิงครั้งเดียวตอนเปิดหน้า — ยอดขยับตอนมีรายการเหรียญเกิดขึ้น ซึ่งไม่ได้เกิดจาก
   * หน้าจอนี้ การ poll ถี่ ๆ จึงเป็นการยิงคำขอทิ้งเปล่าเกือบทุกครั้ง
   * หน้าที่ทำให้ยอดเปลี่ยนเรียก this.props.onWalletChange? — ยังไม่มีหน้านั้น
   * (ตอนนี้เหรียญขยับจากฝั่ง backend เท่านั้น) รีเฟรชหน้าแล้วเห็นยอดใหม่
   *
   * พังก็ปล่อยเงียบ ๆ เหมือน badge — แถบยอดเป็นข้อมูลประกอบ ไม่ใช่สิ่งที่ขาดแล้ว
   * ใช้งานหน้าอื่นไม่ได้ ไม่ควรเด้ง error ใส่ผู้ใช้ตอนเปิดหน้า
   * ========================================================================= */
  GetWallet = async () => {
    try {
      const result = await GET("admin/wallets/overview");
      this.setState({ wallet: result?.status ? result.data : null, wallet_loading: false });
    } catch {
      this.setState({ wallet: null, wallet_loading: false });
    }
  };

  componentDidMount = async () => {
    // ไม่มี token ตั้งแต่ต้น = ยังไม่ได้ล็อกอิน
    if (!tokens) {
      window.location.href = "/login";
      return;
    }

    // token หมดอายุ/ถูกยกเลิก : services/api จะล้าง localStorage แล้วพากลับหน้าล็อกอินเอง
    await this.GetProfile();
    // ต้องมาหลัง GetProfile — รายการเมนูที่กรองตามสิทธิ์แล้วเพิ่งพร้อมตรงนี้
    this.GetBadges();
    this.GetWallet();
  };
  GetProfile = async () => {
    const result = await GET("admin/users/profile");
    if (result?.status) {
      localStorage.setItem("mn-profile", JSON.stringify(result.data));
      this.setState({
        user_profile: result.data,
        array_link: [...this.filterMenu(result.data)],
      });
    }
  };
  async componentDidUpdate() {
    // ถ้าเป็นการกาง/หุบกลุ่มเมนู ไม่ต้องเลื่อนไปที่เมนู active (กันหน้าเด้ง)
    if (this.skip_scroll) {
      this.skip_scroll = false;
    } else {
      const active = document.querySelector(".active");
      if (active) {
        active.focus();
        active.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }
  filterMenu = (profile) => {
    let perms = profile?.role?.permission || [];
    // super_user ข้ามการตรวจสิทธิ์รายหน้าฝั่ง backend อยู่แล้ว (auth.middleware.checkPermission)
    // แถบเมนูจึงต้องไม่กรองด้วย ไม่งั้นจะเห็นน้อยกว่าที่ตัวเองเข้าได้จริง
    const bypass = profile?.user_type === "super_user";
    const allowed = (item) => bypass || !item.permission || perms.includes(item.permission);

    const menu = (global.menu_admin || [])
      .map((item) => {
        if (!item.children) return item;
        // เมนูกลุ่ม : กรองเมนูลูกตามสิทธิ์ ถ้าไม่เหลือลูกเลยให้ตัดทั้งกลุ่มทิ้ง
        const children = item.children.filter(allowed);
        return children.length ? { ...item, children } : null;
      })
      .filter(Boolean)
      .filter((item) => !item.link || allowed(item));

    return menu
      .reduce((acc, item) => {
        if (item.title && acc.at(-1)?.title) return acc;
        acc.push(item);
        return acc;
      }, [])
      .filter((_, i, arr) => !(i === arr.length - 1 && arr[i].title));
  };
  // กางกลุ่มเมนูที่มีเมนูลูกตรงกับหน้าปัจจุบันไว้ตั้งแต่เปิดหน้า
  defaultOpenGroups = () => {
    const path = window.location.pathname;
    return (global.menu_admin || [])
      .filter((item) => item.children)
      .reduce((acc, item) => {
        acc[item.name] = item.children.some((child) => child.link === path);
        return acc;
      }, {});
  };
  toggleGroup = (name) => {
    this.skip_scroll = true;
    this.setState((state) => ({
      open_groups: { ...state.open_groups, [name]: !state.open_groups[name] },
    }));
  };
  // เดิมมี permissionSetting() ที่ลบ DOM ตาม class = permission key ทุกรอบ render
  // ถอดออกแล้ว : ไม่มีหน้าไหนใส่ class เหล่านั้นเลย (จึงไม่เคยทำงาน) และการ .remove()
  // node ที่ React ครองอยู่เสี่ยงพังตอน reconcile
  // ตอนนี้ปุ่มแต่ละหน้าใช้ can() จาก utils/permission แล้วซ่อนด้วย conditional render แทน

  // เมนูที่ตั้ง coming_soon ไว้ใน global.js : กดแล้วแจ้งเตือน ไม่พาไปหน้าไหน
  ComingSoon = (event, item) => {
    event.preventDefault();
    alert("", "info", t("coming_soon_title"), `${t(item.name)} — ${t("coming_soon_desc")}`, t("confirm"));
  };

  /* ปุ่มเปิดกล่องเติมเหรียญ — ไอคอนล้วน ไม่มีป้ายกำกับ
     ปุ่มนี้เกาะอยู่กับชิปยอดเหรียญตลอดเวลา บริบทข้าง ๆ บอกอยู่แล้วว่ากำลังพูดถึงเหรียญ
     ตัวอักษรซ้ำอีกทีจึงเป็นแค่ของกินที่บนหัวหน้าที่มีที่จำกัด ชื่อเต็มอยู่ใน title/aria-label

     หน้าตาเดียวกันทั้งสองฝั่ง (ทั้งไอคอนและสีปุ่ม) เพราะเป็นประตูบานเดียวกันไปหา
     เรื่องเดียวกัน ตัวแปร preview จึงเหลือหน้าที่แค่เปลี่ยนข้อความบอกใบ้ :
     ฝั่งแอดมินขึ้น tooltip ว่าเปิดเข้าไปได้แค่ดู ส่วนความต่างจริง ๆ ไปอยู่ที่ตัวกล่อง
     ที่เปิดออกมา (ดู componentTopup -> TopupModal readonly) */
  topupButton = (preview) => {
    const label = preview ? t("topup_preview_action") : t("topup_action");

    return (
      <button
        type="button"
        className="wlt-topup"
        title={preview ? t("topup_readonly_note") : label}
        aria-label={label}
        onClick={() => this.setState({ topup_open: true })}
      >
        {/* เหรียญตัวเดียวกับชิปยอด + ป้ายบวกมุมขวาล่าง — ฟอนต์ของโปรเจกต์
            (FA5 Pro Light) ไม่มีกลิฟ "เหรียญติดเครื่องหมายบวก" มาให้ในตัว จึงซ้อนเอง
            สองชิ้นนี้ต้องอ่านคู่กัน : เหรียญบอก "ของอะไร" ป้ายบวกบอก "ทำอะไรกับมัน"
            ตัวใดตัวหนึ่งเดี่ยว ๆ ตอบได้แค่ครึ่งเดียว

            ใช้ COIN_ICON ตัวเดียวกับชิปยอดที่นั่งติดกัน ไม่ใช่กลิฟที่พิมพ์ทิ้งไว้ตรงนี้
            เอง — วันไหนเปลี่ยนหน้าตาเหรียญของทั้งระบบที่ wallet_option.js ปุ่มนี้จะ
            เปลี่ยนตามเองโดยไม่ต้องมีใครมานั่งจำว่ามีอีกที่หนึ่งที่ต้องตามไปแก้ */}
        <span className="wlt-topup__icon icon">{COIN_ICON}</span>
        <span className="wlt-topup__plus icon">{"\uf067"}</span>
      </button>
    );
  };

  /* ============================================ แถบยอดเหรียญบนหัวหน้า
   * วางไว้ที่หัวหน้าแทนที่จะเป็นแถบเมนูด้านข้าง เพราะแถบข้างซ่อนตัวเองบนจอเล็ก
   * (d-none d-md-block) ส่วนยอดเหรียญคือสิ่งที่พาร์ตเนอร์ต้องเห็นทุกครั้งที่เปิดระบบ
   * ไม่ว่าจะเปิดจากเครื่องไหน
   *
   * รูปร่างของยอดต่างกันตาม scope ที่ backend ตัดสินให้แล้ว หน้าเว็บไม่ได้เดาเอง
   * จาก user_type ของโปรไฟล์ — ไม่งั้นโปรไฟล์ที่ค้างอยู่ใน localStorage จะทำให้
   * วาดผิดฝั่งชั่วครู่ทุกครั้งที่เปิดหน้า
   * ========================================================================= */
  componentWallet = () => {
    const { wallet, wallet_loading } = this.state;

    /* ยังไม่รู้ว่าตัวเองเป็น scope ไหน — วางโครงชิปไว้ก่อนกันหัวหน้าขยับตอนยอดมาถึง
       เดาจาก user_type ที่แคชไว้ได้แค่ "จะมีชิปไหม" เท่านั้น ตัวเลขและ scope จริง
       รอจาก backend เสมอ (โปรไฟล์ใน localStorage อาจเก่ากว่าความจริง) */
    if (wallet_loading) {
      if (!WALLET_SCOPES.includes(this.state.user_profile?.user_type)) return null;

      return (
        <div className="wlt-chip wlt-chip--loading" aria-hidden="true">
          <span className="wlt-chip__coin icon">{COIN_ICON}</span>
          <span className="wlt-chip__body">
            <span className="wlt-chip__label">{t("wallet_coin")}</span>
            <span className="wlt-chip__value">0000</span>
          </span>
        </div>
      );
    }

    // ยิง overview ไม่ผ่าน — ไม่รู้ว่าตัวเองเป็น scope ไหน ไม่ต้องเดาว่าจะวาดอะไร
    if (!wallet) return null;

    const preview = can(TOPUP_PREVIEW_PERMISSIONS);

    /* ผู้ใช้ภายในที่ไม่ใช่ super_user — ไม่มีกระเป๋าให้ดูและไม่ได้ดูแลยอดรวม
       จึงไม่มีชิปยอด เหลือแค่ปุ่มเปิดฟอร์มเติมดูอย่างเดียวสำหรับคนที่ดูแลระบบเหรียญ */
    if (wallet.scope === "none") return preview ? this.topupButton(true) : null;

    /* ---------------------------------------------- พาร์ตเนอร์ : กระเป๋าของตัวเอง */
    if (wallet.scope === "own") {
      // อนุมัติแล้วทุกคนต้องมีกระเป๋า — ไม่มีคือใบเก่าที่ตกหล่น ซ่อนแถบไว้ดีกว่าโชว์ 0
      if (!wallet.wallet) return null;

      const frozen = wallet.wallet.status === "frozen";

      /* ชิปยอด + ปุ่มเติมรวมเป็นเม็ดเดียวกัน ไม่ใช่สองชิ้นลอยข้างกัน — บนหัวสีขาว
         ที่มีของอยู่ไม่กี่ชิ้น สองก้อนแยกกันจะดูเหมือนของหลุดมาวาง ส่วนเม็ดเดียว
         ที่มีเส้นคั่นบาง ๆ อ่านได้ทันทีว่า "ยอดของฉัน กับสิ่งที่ทำกับยอดนี้ได้" */
      return (
        <div className="wlt-pack">
          <div
            className={`wlt-chip${frozen ? " wlt-chip--frozen" : ""}`}
            title={frozen ? t("wallet_frozen_hint") : t("wallet_my_coin")}
          >
            <span className="wlt-chip__coin icon">{COIN_ICON}</span>
            <span className="wlt-chip__body">
              <span className="wlt-chip__label">{frozen ? t("wallet_status_frozen") : t("wallet_my_coin")}</span>
              <span className="wlt-chip__value">
                {coin(wallet.wallet.balance)}
                <span className="wlt-chip__unit">{t("wallet_unit_coin")}</span>
              </span>
            </span>
          </div>

          {/* ปุ่มเติมเหรียญ — ติดกับยอดโดยตั้งใจ : คนที่คิดจะเติมคือคนที่เพิ่งเห็นว่ายอด
              ตัวเองใกล้หมด ปุ่มจึงควรอยู่ตรงนั้น ไม่ใช่ซ่อนอยู่ในเมนูอีกชั้น
              จอแคบเหลือแต่ไอคอน (ป้ายกำกับซ่อนด้วย CSS เหมือนที่ชิปทำ)

              กระเป๋าที่ถูกระงับไม่มีปุ่มนี้ — บัญชีที่โดนระงับไม่ควรถูกชวนให้โอนเงินเข้ามา
              (ยอดที่ค้างจ่ายยังเข้ากระเป๋าได้ตามปกติ นั่นคนละเรื่องกับการเติมเอง) */}
          {!frozen && this.topupButton(false)}
        </div>
      );
    }

    /* ------------------------------------------ super_user : ยอดรวมทั้งระบบ */
    const total = wallet.total || {};

    const chip = (
      <div className="wlt-chip" title={t("wallet_total_coin")}>
        <span className="wlt-chip__coin icon">{COIN_ICON}</span>
        <span className="wlt-chip__body">
          <span className="wlt-chip__label">{t("wallet_total_coin")}</span>
          <span className="wlt-chip__value">
            {/* เต็มจำนวนเสมอ เหมือนยอดของพาร์ตเนอร์ — ยอดรวมทั้งระบบคือตัวเลขที่เอาไป
                กระทบยอดจริง การย่อเป็น 1.2M ทำให้ต้องเอาเมาส์ไปชี้ทุกครั้งที่อยากรู้ค่าจริง */}
            {coin(total.balance)}
            <span className="wlt-chip__unit">{t("wallet_unit_coin")}</span>
          </span>
        </span>
      </div>
    );

    /* มีปุ่มดูฟอร์มด้วยก็รวมเป็นเม็ดเดียวแบบฝั่งพาร์ตเนอร์ ไม่ใช่สองก้อนลอยข้างกัน
       ไม่มีปุ่ม (สิทธิ์ไม่ถึง) ก็เป็นชิปเดี่ยวตามเดิม ไม่ต้องมีกรอบซ้อนกรอบ */
    if (!preview) return chip;

    return (
      <div className="wlt-pack">
        {chip}
        {this.topupButton(true)}
      </div>
    );
  };

  /* กล่องเติมเหรียญ — วาดครั้งเดียวที่นี่ ถึงแม้ปุ่มเปิดจะมีสองชุด
     (นอก Navbar.Collapse สำหรับจอเล็ก และในกลุ่มชื่อผู้ใช้สำหรับจอใหญ่)

     พาร์ตเนอร์กรอกและส่งคำขอได้จริง ส่วนแอดมินเปิดได้แบบอ่านอย่างเดียว : เห็นฟอร์ม
     เดียวกันเป๊ะ ๆ ด้วยอัตราและบัญชีรับเงินของจริง แต่ส่งคำขอไม่ได้ เพราะคำขอเติม
     ต้องผูกกับกระเป๋าของผู้ขอ ซึ่งมีแต่พาร์ตเนอร์เท่านั้นที่มี */
  componentTopup = () => {
    const { wallet, topup_open } = this.state;
    if (!wallet) return null;

    const own = wallet.scope === "own";
    // พาร์ตเนอร์ที่อนุมัติแล้วแต่ไม่มีกระเป๋า = ใบเก่าที่ตกหล่น ไม่มีอะไรให้เติม
    if (own && !wallet.wallet) return null;
    if (!own && !can(TOPUP_PREVIEW_PERMISSIONS)) return null;

    return (
      <TopupModal
        show={topup_open}
        /* อ่านอย่างเดียว = ปิดทุกช่องกรอกและถอดปุ่มส่งออก (ดู TopupModal)
           ตัวกันจริงอยู่ที่ backend — ที่นี่กันไม่ให้กรอกทิ้งเปล่าเฉย ๆ */
        readonly={!own}
        balance={own ? wallet.wallet.balance : 0}
        /* อัตราแลกเปลี่ยน เพดานเติม และบัญชีรับเงิน — ตั้งไว้ที่หน้า ตั้งค่า › ตั้งค่าเหรียญ
           แล้ว backend ส่งมาพร้อมยอดตรงนี้ (พาร์ตเนอร์ไม่มีสิทธิ์อ่านหน้าตั้งค่าเอง) */
        coin={wallet.coin}
        onHide={() => this.setState({ topup_open: false })}
      />
    );
  };

  // ปุ่มลัดไปหน้าเว็บลูกค้า — วางไว้ล่างสุดของแถบเมนู (นิยามใน global.menu_admin_cta)
  componentCta = () => {
    const item = global.menu_admin_cta;
    const perms = this.state.user_profile?.role?.permission || [];
    if (!item || (item.permission && !perms.includes(item.permission))) return null;

    return (
      <a
        href={item.link}
        target={item.new_tab ? "_blank" : undefined}
        rel={item.new_tab ? "noreferrer" : undefined}
        className="sidebar-cta d-flex align-items-center justify-content-center gap-2 mb-2 px-3 py-2 text-decoration-none"
      >
        <span className="icon">{item.icon}</span>
        <span>{t(item.name)}</span>
      </a>
    );
  };

  componentMenu = () => {
    const classNameBTN =
      "nav-link-sidebar d-flex align-items-center py-2 px-3 mb-1 rounded-lg text-decoration-none";
    const classNameICON = "icon wpx-24 text-center me-3";
    const currentPath = window.location.pathname;
    const currentType =
      new URLSearchParams(window.location.search).get("type") || "";
    const hrefOf = (item) => `${item.link}${item.type ? `?type=${item.type}` : ""}`;
    const isActive = (item) =>
      !!item.link &&
      item.link === currentPath &&
      (item.type || "") === currentType;

    const soonBadge = <span className="sidebar-soon">{t("coming_soon")}</span>;

    const linkItem = (href, icon, label, active, extra = null, item = null) => (
      <a
        href={href}
        target={item?.new_tab ? "_blank" : undefined}
        rel={item?.new_tab ? "noreferrer" : undefined}
        className={`${classNameBTN} ${active ? "active" : ""} ${item?.coming_soon ? "is-soon" : ""}`}
        onClick={item?.coming_soon ? (e) => this.ComingSoon(e, item) : undefined}
      >
        <span className={classNameICON}>
          {icon}
        </span>
        <span className="flex-grow-1">{t(label)}</span>
        {item?.coming_soon && soonBadge}
        {extra}
        {}
      </a>
    );

    const { array_link, open_groups, user_profile } = this.state;

    return (
      <div className="sidebar-menu">
        {array_link.map((item, i) => {
          // หัวข้อคั่นกลุ่ม
          if (item.title)
            return (
              <div className="sidebar-section-title text-uppercase small fw-semibold px-3 py-2 mt-1 mb-1" key={`title-${i}`}>
                {t(item.title)}
              </div>
            );

          // ปุ่มเด่น เช่น "เพิ่มทรัพย์" หรือ "ดูหน้าเว็บลูกค้า"
          // (สีเดียวกับปุ่มหลักหน้า login) ตั้ง new_tab: true เพื่อเปิดแท็บใหม่
          if (item.cta)
            return (
              <a
                key={`cta-${i}`}
                href={item.link}
                target={item.new_tab ? "_blank" : undefined}
                rel={item.new_tab ? "noreferrer" : undefined}
                className="sidebar-cta d-flex align-items-center justify-content-center gap-2 my-2 px-3 py-2 text-decoration-none"
              >
                <span className="icon">{item.icon}</span>
                <span>{t(item.name)}</span>
              </a>
            );

          // เมนูกลุ่ม : กด header เพื่อกาง/หุบเมนูลูก
          if (item.children) {
            const opened = !!open_groups[item.name];
            const childActive = item.children.some(isActive);
            return (
              <div key={`group-${i}`}>
                <button
                  type="button"
                  aria-expanded={opened}
                  className={`${classNameBTN} sidebar-group w-100 border-0 bg-transparent ${
                    childActive && !opened ? "active" : ""
                  }`}
                  onClick={() => this.toggleGroup(item.name)}
                >
                  <span className={classNameICON}>{item.icon}</span>
                  <span className="flex-grow-1 text-start">{t(item.name)}</span>
                  <span className={`icon sidebar-caret ${opened ? "opened" : ""}`}>
                    {"\uf078"}
                  </span>
                </button>
                {opened && (
                  <div className="sidebar-submenu">
                    {item.children.map((child, j) => (
                      <a
                        key={`child-${i}-${j}`}
                        href={hrefOf(child)}
                        className={`${classNameBTN} nav-link-sub ${
                          isActive(child) ? "active" : ""
                        } ${child.coming_soon ? "is-soon" : ""}`}
                        onClick={child.coming_soon ? (e) => this.ComingSoon(e, child) : undefined}
                      >
                        <span className="sidebar-dot" />
                        <span className="flex-grow-1">{t(child.name)}</span>
                        {child.coming_soon && soonBadge}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            );
          }

          if (!item.link) {
            return null;
          }
          // ตัวเลขงานค้าง — ไม่มีงานค้าง (0) ไม่ต้องโชว์ ป้ายศูนย์ไม่ได้บอกอะไร
          const count = item.badge ? this.state.badges[item.badge] || 0 : 0;

          return linkItem(
            hrefOf(item),
            item.icon,
            item.name,
            isActive(item),
            count > 0 ? <span className="sidebar-badge">{count > 99 ? "99+" : count}</span> : item.component,
            item,
          );
        })}

        {/* <hr className="my-3 mx-3 sidebar-divider" /> */}

        {/* จอเล็กไม่มีแถบล่างแบบตรึง จึงวางปุ่มไว้ท้ายรายการเมนูแทน */}
        <div className="d-block d-md-none mt-2">{this.componentCta()}</div>

        {/* จอเล็กไม่มีการ์ดผู้ใช้ที่แถบข้าง จึงให้แถวนี้บอกด้วยว่ากำลังใช้บัญชีไหนอยู่
            คนที่เปิดกล่องบัญชีไม่ได้ (พาร์ตเนอร์) ยังต้องเห็นชื่อบัญชีเหมือนเดิม
            แค่เป็นป้ายเฉย ๆ ไม่ใช่ปุ่มที่กดแล้วไม่มีอะไรเกิดขึ้น */}
        <div className="d-block d-md-none mt-3">
          {(() => {
            const clickable = this.canOpenAccount();
            const Tag = clickable ? "button" : "div";

            return (
              <Tag
                {...(clickable ? { type: "button", onClick: this.OpenAccount } : {})}
                className={`sidebar-user d-flex align-items-center text-start w-100 p-2 rounded-lg${clickable ? " sidebar-user-btn" : ""}`}
              >
                <span
                  className="user-avatar me-2 wpx-36 hpx-35 d-flex align-items-center justify-content-center"
                  style={{ fontSize: "0.8rem", flex: "0 0 36px" }}
                >
                  {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                </span>
                <span className="flex-grow-1 overflow-hidden">
                  <span className="d-block text-14 fw-semibold text-truncate" style={{ color: "var(--mn-ink)" }}>
                    {clickable ? t("my_account") : user_profile?.full_name || "Username"}
                  </span>
                  <span className="d-block text-12 text-truncate" style={{ marginTop: -2, color: "var(--mn-muted)" }}>
                    {clickable
                      ? user_profile?.full_name || user_profile?.email || "Username"
                      : user_profile?.role?.name || user_profile?.email || ""}
                  </span>
                </span>
                {clickable && (
                  <span className="icon ms-2" style={{ color: "var(--mn-muted)", fontSize: "0.75rem" }}>
                    {"\uf054"}
                  </span>
                )}
              </Tag>
            );
          })()}
        </div>

        {/* จอเล็กไม่มีที่ว่างบนแถบหัวสำหรับตัวเลือกภาษา (แถบหัวเหลือแค่โลโก้ ยอดเหรียญ
            และปุ่มพับ) ถ้าไม่วางซ้ำไว้ตรงนี้ TH/EN จะหายไปเลยตอนเมนูยุบ */}
        <div className="d-block d-md-none mt-3 px-2">
          <div className="text-12 mb-1" style={{ color: "var(--mn-muted)" }}>{t("language")}</div>
          <Language />
        </div>

        <div className="d-block d-md-none mt-1">
          <button
            type="button"
            className={`${classNameBTN} w-100 text-danger border-0 bg-transparent`}
            onClick={() => {
              this.Logout();
            }}
          >
            <span className={classNameICON}>
              {"\uf2f5"}
            </span>
            <span className="flex-grow-1 text-start">{t("logout")}</span>
          </button>
        </div>
        <div className="d-none d-md-block hpx-100"></div>
      </div>
    );
  };
  // ===== บัญชีของฉัน : การผูก LINE =====

  /* การผูกบัญชี LINE ยังไม่เปิดใช้ฝั่งพาร์ตเนอร์ — และกล่อง "บัญชีของฉัน" ตอนนี้มีเรื่องนี้
     อยู่เรื่องเดียว ซ่อนเฉพาะแถว LINE จะเหลือกล่องเปล่าที่กดเข้าไปแล้วไม่ได้อะไร จึงปิด
     ตั้งแต่ปุ่มทางเข้า เอาเงื่อนไขนี้ออกเมื่อเปิดใช้กับพาร์ตเนอร์ หรือเมื่อกล่องมีเรื่องอื่นเพิ่ม */
  canOpenAccount = () => !isPartnerUser(this.state.user_profile);

  OpenAccount = async () => {
    if (!this.canOpenAccount()) return;

    this.setState({ modal_account: true, line_status: null });

    const result = await GET("auth/line/status");
    if (result?.status !== true) return;

    this.setState({ line_status: result.data });
  };

  // backend เป็นคนสร้างลิงก์และฝัง user_id ไว้ใน state ที่เซ็นแล้ว
  // LINE จะพากลับมาที่ /auth/line/callback ซึ่งผูกบัญชีให้โดยไม่ต้องถามรหัสผ่านซ้ำ
  LinkLine = async () => {
    loading(true);
    const result = await GET("auth/line/link-url");

    if (result?.status !== true || !result.data?.authorize_url) {
      loading(false);
      return;
    }

    window.location.href = result.data.authorize_url;
  };

  UnlinkLine = async () => {
    if (!(await alert("", "warning", t("confirm"), t("line_unlink_ask"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await DELETE("auth/line/unlink");
    loading(false);

    if (result?.status !== true) return;

    await alert("", "success", t("success"), t("line_unlinked_success"));
    this.OpenAccount();
  };

  componentAccountModal = () => {
    const { modal_account, line_status, user_profile } = this.state;

    return (
      <Modal
        size="md"
        show={modal_account}
        onHide={() => this.setState({ modal_account: false })}
        centered
        contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
      >
        <Modal.Header className="account-modal-header">
          <div className="d-flex align-items-center gap-3 pe-5">
            <span className="user-avatar d-flex align-items-center justify-content-center flex-shrink-0">
              {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
            </span>
            <div className="overflow-hidden">
              <h5 className="fw-bold mb-0 text-truncate" style={{ color: "var(--mn-ink)" }}>
                {user_profile?.full_name || t("my_account")}
              </h5>
              <div className="account-hint text-truncate">
                {user_profile?.email || user_profile?.role?.name || ""}
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="account-modal-body">
          <span className="account-section-label">{t("connected_accounts")}</span>

          {/* ยังไม่ได้ตั้งค่า LINE Login ฝั่งเซิร์ฟเวอร์ = ไม่ต้องโชว์ปุ่มให้กดแล้วพัง */}
          {line_status && !line_status.enabled ? (
            <div className="account-row text-secondary text-13">{t("line_login_disabled")}</div>
          ) : (
            <div className="account-row">
              {/* รูปโปรไฟล์ LINE มาจากภายนอก ต้องล็อกขนาดไว้ ไม่งั้นดันโมดัลจนล้น */}
              {line_status?.picture_url ? (
                <img src={line_status.picture_url} alt="" className="account-avatar" />
              ) : (
                <span className="account-avatar account-avatar--line">LINE</span>
              )}

              <div className="account-row-body">
                <div className="account-row-title">LINE</div>
                <div className="account-row-desc text-truncate">
                  {line_status === null
                    ? t("loading")
                    : line_status.linked
                      ? line_status.display_name || line_status.email || t("line_linked")
                      : t("line_not_linked")}
                </div>
              </div>

              {line_status !== null && (
                line_status.linked ? (
                  <button type="button" className="account-btn account-btn--ghost account-btn--danger" onClick={this.UnlinkLine}>
                    {t("line_unlink")}
                  </button>
                ) : (
                  <button type="button" className="account-btn account-btn--line" onClick={this.LinkLine}>
                    {t("line_link")}
                  </button>
                )
              )}
            </div>
          )}

          <div className="account-hint mt-3">{t("line_link_hint")}</div>
        </Modal.Body>

        <Modal.Footer className="account-modal-footer">
          <button type="button" className="account-btn account-btn--ghost" onClick={() => this.setState({ modal_account: false })}>
            {t("close")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  Logout = async () => {
    // TODO: กลับมาเปิดใช้เมื่อมี flow portal / หลาย module
    // const { user_profile } = this.state;
    // if (["super_user"].includes(user_profile?.user_type)) {
    //   window.location.href = "/portal";
    //   return;
    // }
    // let module = [];
    // const perms = user_profile?.role?.permission || [];
    // if (global.hasModuleAccess(global.menu_admin, perms)) module.push("admin");
    // if (global.hasModuleAccess(global.menu_customer, perms)) module.push("customer");
    // if (global.hasModuleAccess(global.menu_warehouse, perms)) module.push("warehouse");
    // if (module.length > 1) {
    //   window.location.href = "/portal";
    //   return;
    // }

    if (
      await alert(
        "",
        "warning",
        t("confirm"),
        t("logout_ask"),
        t("logout"),
        t("cancel"),
      )
    ) {
      loading(true);
      // ยกเลิก token ฝั่ง server ก่อน — ถ้าเรียกไม่สำเร็จ (เช่น token หมดอายุไปแล้ว)
      // ก็ยังต้องล้างฝั่ง client ต่อ ไม่งั้นผู้ใช้จะค้างอยู่ในระบบ
      await POST("auth/logout");
      loading(false);

      localStorage.clear();
      window.location.href = "/login";
    }
  };

  render() {
    const {
      user_profile,
    } = this.state;
    return (
      <div className="hpx-50">
        {/* วางไว้นอกแถบข้าง เพราะแถบข้างซ่อนบนจอเล็ก (d-none d-md-block) */}
        {this.canOpenAccount() && this.componentAccountModal()}
        {this.componentTopup()}
        <Navbar
          className="px-3 px-md-4 bg-white position-fixed w-100"
          style={{ zIndex: 1020, border: "0", borderBottom: "1px solid var(--mn-line)" }}
          expand="md"
        >
          <Navbar.Brand href={global.getAdminHomeLink(user_profile)} className="fw-bold text-dark d-flex pointer">
            <Logo size={38} version />
          </Navbar.Brand>
          {/* จอเล็ก : ยอดเหรียญอยู่นอก Navbar.Collapse โดยตั้งใจ — ต้องเห็นทันทีที่เปิดหน้า
              ไม่ใช่ซ่อนอยู่หลังปุ่มแฮมเบอร์เกอร์ (จอใหญ่วาดอีกชุดไว้ข้างตัวเลือกภาษา) */}
          <div className="d-flex align-items-center gap-2 d-md-none">
            {this.componentWallet()}
            <Navbar.Toggle className="border-0" aria-controls="basic-navbar-nav"/>
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="d-none d-md-flex align-items-center">
                <Language/>
                <div className="hpx-40 mx-3" style={{ width: 1, backgroundColor: 'var(--mn-line)' }}/>
                {/* ยอดเหรียญกับชื่อผู้ใช้เป็นกลุ่มเดียวกัน — "ฉันเป็นใคร + ฉันมีเท่าไร"
                    ไม่มีเส้นคั่นระหว่างกัน ส่วนภาษาเป็นค่าตั้งค่ากลางของหน้าจอ ไม่ได้ผูก
                    กับบัญชีใคร จึงถอยไปอยู่ซ้ายสุดของกลุ่มโดยมีเส้นคั่นกั้นไว้
                    gap-2 คุมช่องไฟให้เอง ไม่ว่าจะมีชิปเหรียญหรือไม่ */}
                <div className="d-flex align-items-center gap-2">
                  {this.componentWallet()}
                  <div className="d-flex align-items-center text-start user-badge px-2 py-1 rounded-lg">
                    <span className="user-avatar me-2 wpx-32 hpx-32 d-flex align-items-center justify-content-center" style={{ fontSize: '0.75rem' }}>
                      {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                    </span>
                    <div className="pe-2">
                      <div className="text-14 fw-semibold text-dark">
                        {user_profile?.full_name || "Username"}
                      </div>
                      <div className="text-12 text-secondary" style={{ marginTop: -2 }}>
                        {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-block d-md-none mb-5 pt-4 overflow-scroll" style={{ height: "80vh" }}>
                {this.componentMenu()}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div
          className="position-fixed wpx-260 sidebar-light overflow-scroll d-none d-md-block"
          style={{
            zIndex: 1021,
            height: "100vh",
            border: "0",
          }}
        >
          <div
            className="d-flex pt-3 position-fixed sidebar-light pb-3 px-3 wpx-260 sidebar-brand"
            style={{
              border: "0",
            }}
          >
            <Logo size={38} version />
          </div>
          <div className="px-3 mb-5" style={{ marginTop: 60 }}>
            {this.componentMenu()}
          </div>
          <div
            className="position-fixed sidebar-light pb-3 px-3 wpx-260"
            style={{
              bottom: 0,
              border: "0",
              borderTop: "1px solid var(--mn-line)",
              paddingTop: "12px",
            }}
          >
            {this.componentCta()}
            <div className="sidebar-user d-flex align-items-center text-start w-100 p-2 rounded-lg">
              <span className="user-avatar me-2 wpx-36 hpx-35 d-flex align-items-center justify-content-center" style={{ fontSize: '0.8rem' }}>
                {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
              </span>
              <div className="flex-grow-1 overflow-hidden">
                <div className="text-14 fw-semibold text-truncate" style={{ color: 'var(--mn-ink)' }}>
                  {user_profile?.full_name || "Username"}
                </div>
                <div className="text-12 text-truncate" style={{ marginTop: -2, color: 'var(--mn-muted)' }}>
                  {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                </div>
              </div>
              {/* พาร์ตเนอร์ยังเปิดกล่องบัญชีไม่ได้ (ดู canOpenAccount) จึงไม่ต้องมีปุ่มนี้ */}
              {this.canOpenAccount() && (
                <button
                  type="button"
                  className="sidebar-user-action ms-1"
                  onClick={this.OpenAccount}
                  title={t("my_account")}
                  aria-label={t("my_account")}
                >
                  <span className="icon">{""}</span>
                </button>
              )}
              <button
                type="button"
                className="sidebar-user-action sidebar-user-action--danger"
                onClick={() => {
                  this.Logout();
                }}
                title={t("logout")}
                aria-label={t("logout")}
              >
                <span className="icon">{"\uf08b"}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
